import { __assign } from "tslib";
/* eslint-disable @wix/da/create-action-payload-creator */
import { useMemo, useReducer } from 'react';
import { FolderType } from './redux/types';
import { createAction } from 'redux-actions';
var setSelectedGroup = createAction('selectGroup');
var resetSelectedGroup = createAction('resetGroup');
var setSelectedSubmissionType = createAction('selectType');
var setFilter = createAction('setFilter');
var initialState = {
    selectedSubmissionType: FolderType.Gallery,
    filterValue: '',
};
function reducer(prevState, action) {
    switch (action.type) {
        case 'selectGroup':
            return __assign(__assign({}, prevState), { selectedGroup: action.payload, filterValue: '' });
        case 'resetGroup':
            return initialState;
        case 'selectType':
            return __assign(__assign({}, prevState), { selectedSubmissionType: action.payload, filterValue: '' });
        case 'setFilter':
            return __assign(__assign({}, prevState), { filterValue: action.payload });
        default:
            return prevState;
    }
}
export function useAddToGroupFlow() {
    var _a = useReducer(reducer, initialState), _b = _a[0], selectedGroup = _b.selectedGroup, selectedSubmissionType = _b.selectedSubmissionType, filterValue = _b.filterValue, dispatch = _a[1];
    return useMemo(function () { return ({
        selectedGroup: selectedGroup,
        selectedSubmissionType: selectedSubmissionType,
        filterValue: filterValue,
        selectGroup: function (group) { return dispatch(setSelectedGroup(group)); },
        resetSelectedGroup: function () { return dispatch(resetSelectedGroup()); },
        selectSubmissionType: function (type) {
            return dispatch(setSelectedSubmissionType(type));
        },
        onFilterInputChange: function (e) {
            return dispatch(setFilter(e.target.value));
        },
    }); }, [filterValue, selectedGroup, selectedSubmissionType]);
}
//# sourceMappingURL=useAddToGroupFlow.js.map